var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('VueAutonumeric',{staticClass:"form-control auto-numeric",attrs:{"options":{
      allowDecimalPadding: false,
      digitGroupSeparator: '',
      decimalCharacter: ',',
      decimalPlaces: 10,
      decimalCharacterAlternative: '.',
      currencySymbol: '\u00a0€',
      currencySymbolPlacement: 's',
      roundingMethod: 'U',
      emptyInputBehavior: 'zero',
      symbolWhenUnfocused: '',
      selectOnFocus: 'false',
      currencySymbol: '',
      negativePositiveSignPlacement: 'p'
    }},on:{"blur":_vm.onBlur},model:{value:(_vm.convertedValue),callback:function ($$v) {_vm.convertedValue=$$v},expression:"convertedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }